import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryService} from "../../services/category/category.service";
import {IAppConfig} from "../../models/app-config.model";
import {AppConfig} from "../../services/app.config";



@Component({

  selector: 'rw-marketplace-company-list',  // <home></home>

  styles: [require('./marketplace-company-list.component.scss')],

  template: require('./marketplace-company-list.component.html')
})
export class MarketplaceCompanyListComponent implements OnInit,OnChanges {

  @Input() public company:CompanyVM;
  public companyList:CompanyVM[];
  public setting: IAppConfig = AppConfig.settings;
  marketPlace : any ;
  marketPlaceType : string = 'ENTERPRISE';
  themeCompanyListType : string = 'CARD';
  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute:ActivatedRoute , private router:Router, private companyService:CompanyService) {
  }



  public ngOnInit() {
    this.companyService.getCompanyInfo().subscribe((c) => {
      this.companyService.getMarketPlaceByKeyUrl(c.keyUrl).subscribe((m) => {
        this.marketPlace = m;
        this.marketPlaceType = m.title;
      })
      if (c && c.setting && c.setting.themeSettingInfo && c.setting.themeSettingInfo.themeServiceListType)
        this.themeCompanyListType = c.setting.themeSettingInfo.themeServiceListType;

    })
    this.loadCompanyList();
  }

  setCategory(category):void
  {
  }
  ngOnChanges(changes:SimpleChanges):void {
    let parent=this;
      if(this.company)
      {

      }
  }
  loadCompanyList(){
    let parent=this;
    this.companyService.getCompanyListByMarketPlaceCompanyId(this.company.id).subscribe(function(companies){
     if( companies ) {

       parent.companyList = companies ;
       parent.loadCompaniesImage();
     }
    })
  }

  loadCompaniesImage(){
    this.companyList.forEach((company)=>{
      // company.imageUrl = this.companyService.makeImageUrl('company', null, company.activityType, false);
      this.getCompanyCardImage(company);
    })
  }

  getCompanyCardImage(com) {
    let parent = this;
    com.coverImage = null;
    com.imageUrl = this.companyService.makeImageUrl('company', com.coverImage, com.activityType, false);
    if (com && com.setting && com.setting.themeSettingInfo) {
      let albumid = com.setting.themeSettingInfo.albumInfoId;
      this.companyService.getMarketPlaceCompanyImageCardByAlbumId(albumid).subscribe((image) => {
        if (image) {

          if(image && image.id)
            com.coverImage = image;
          else
            com.coverImage = null;

          com.imageUrl = this.companyService.makeImageUrl('company', image, com.activityType, false);
        }
      });

    }
  }

  goToCompanyLink(com)
  {
    // if(company.keyUrl)
    // {
    //   let url = 'https://'+company.keyUrl;
    //   if(this.setting.ui.app_name == 'planovin')
    //     url = url+'.' + this.setting.ui.app_name + '.com'
    //   if(this.setting.ui.app_name == 'reserweb')
    //     url = url + this.setting.ui.app_name + '.ir'
    //
    //   window.location.href = url;
    // }

    if(this.company.category && this.company.category == 'LEVEL_1')
    {
      this.router.navigate(['/companyProfileParent', com.keyUrl])
    }
    else
    {
      this.router.navigate(['/companyProfile', com.keyUrl])
    }
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/marketplace-company-list/marketplace-company-list.component.ts